import React, { useEffect, useState } from 'react'
import Layout from '../component/layout'
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom'
import { getItem } from "../../../utils/localStorage";
import { makeRequest2 } from "../../../utils/makeRequest";
import { toastify } from "../../../utils/toast";
import { landlordUnitsURL } from "../../../utils/urls";


const OccupancyReports = () => {
  const navigate = useNavigate();
  const [units, setUnits] = useState([]);


  const fetchResidentUnits = async () => {
    try {
      const customerId = await getItem("selectedCustomerId");
      const facilityId = await getItem("selectedFacilityId");

      const response = await makeRequest2(
        `${landlordUnitsURL}/${facilityId}/${customerId}`, "GET", {});

      if (response.success) {
        setUnits(response.data);
      } else {
        throw new Error(response.error);
      }
    } catch (err) {
      toastify(err.message, "error");
    }
  };

  const occupiedUnits = units.filter(
    (unit) => unit.tenantId && unit.residentId
  );

  const nonOccupiedUnits = units.filter(
    (unit) => !(unit.tenantId && unit.residentId)
  );


  useEffect(() => {
    fetchResidentUnits();
  }, []);

  return (
    <Layout>
      <div className="row">
        <div className="col-sm-12">

          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 ms-3">
                      <h6 className="mb-0">Occupied Units</h6>
                    </div>
                  </div>

                  <div className="row">
                    {occupiedUnits.map((unit, index) => (
                      <div
                        key={`occupied-${index}`}
                        className="col-md-3"
                        style={{ borderColor: "green", borderWidth: 2, cursor: "pointer" }}
                        onClick={() => navigate(`/portal/occupancy_reports/view_unit/${unit._id}`)}
                      >
                        <div className="bg-body p-3 mt-3 rounded">
                          <div className="mt-3 row align-items-center">
                            <div className="col-12">
                              <span>
                                Unit Name: <strong>{unit.name}</strong>
                              </span>
                              <br />
                              <span>
                                Unit Type: <strong>{unit.unitType}</strong>
                              </span>
                              <br />
                              <span className="badge rounded-pill text-bg-info mt-2">
                                <strong>Home Owner</strong>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="d-flex align-items-center mt-4">
                    <div className="flex-grow-1 ms-3">
                      <h6 className="mb-0 text-danger">Non-Occupied Units</h6>
                    </div>
                  </div>

                  <div className="row">
                    {nonOccupiedUnits.map((unit, index) => (
                      <div
                        key={`nonoccupied-${index}`}
                        className="col-md-3"
                        style={{ borderColor: "gray", borderWidth: 2, cursor: "pointer" }}
                        onClick={() => navigate(`/portal/occupancy_reports/view_unit/${unit._id}`)}
                      >
                        <div className="bg-body p-3 mt-3 rounded">
                          <div className="mt-3 row align-items-center">
                            <div className="col-12">
                              <span>
                                Unit Name: <strong>{unit.name}</strong>
                              </span>
                              <br />
                              <span>
                                Unit Type: <strong>{unit.unitType}</strong>
                              </span>
                              <br />
                              <span className="badge rounded-pill text-bg-info mt-2">
                                <strong>Home Owner</strong>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </Layout >
  )
}

export default OccupancyReports